import { ApiParams, ApiResponse } from '@models/api.model.ts';
import axiosInstance from '@api/axios-instance.ts';
import { ProductCategoriesModel } from '@models/product-categories.model.ts';

export const getProductCategories = async (
  params?: ApiParams
): Promise<ApiResponse<ProductCategoriesModel>> => {
  const response = await axiosInstance.get('/pms/inventory-categories/getter', {
    params
  });
  return response.data;
};

export const createProductCategories = async (
  body: any
): Promise<ProductCategoriesModel> => {
  return await axiosInstance.post(`/pms/inventory-categories`, body);
};

export const editProductCategories = async (
  body: any,
  id: number
): Promise<ProductCategoriesModel> => {
  return await axiosInstance.put(`/pms/inventory-categories/${id}`, body);
};

export const deleteProductCategories = async (id: number): Promise<void> => {
  return await axiosInstance.delete(`/pms/inventory-categories/${id}`);
};
